// export 文を使って関数 greet1 を定義
export const topMvSlider = () => {
  $(function () {
    const mvSlider = $(".js-topmv-slider");

    mvSlider.slick({
      autoplaySpeed: 6000,
      autoplay: true,
      speed: 1500,
    });

    // blog箇所
    let sliderInitialized = false; // スライダーが初期化されているかを判定
    const blogSlider = $(".js-top-blogSlider");

    function initializeSlick() {
      if (window.innerWidth <= 768) {
        // SP用ブレイクポイント（768px以下）
        if (!sliderInitialized) {
          // スライダーが未初期化の場合
          blogSlider.slick({
            autoplaySpeed: 3000,
            autoplay: true,
            speed: 1000,
            infinite: true, // 無限スクロール
            slidesToShow: 1, // 表示するスライド数
            slidesToScroll: 1, // 一度にスクロールするスライド数
          });
          sliderInitialized = true;
        }
      } else {
        // PC用ではスライダーを破棄
        if (sliderInitialized) {
          blogSlider.slick("unslick"); // slickの解除
          sliderInitialized = false;
        }
      }
    }

    // ページ読み込み時とリサイズ時にスライダーを切り替え
    initializeSlick();
    $(window).on("resize", function () {
      initializeSlick();
    });
  });
};
